import React, { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import { FullScreenLoader } from 'components/FullScreenLoader';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShopifyService } from 'services/shopify-service';
import { SubscriptionService } from 'services/subscription-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { BillingSession } from 'shared/interfaces/CustomerPortalSession';

export function SubscriptionRedirectHandlerPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { trialProductId, productId } = queryString.parse(location.search);

  const subscriptionHandlingMutation = useMutation({
    mutationFn: ({
      redirectPath,
      productId,
      trialProductId
    }: {
      redirectPath?: string;
      trialProductId?: string;
      productId?: string;
    }) => {
      if (trialProductId && !productId)
        return SubscriptionService.startSubscriptionTrial({ redirectPath, productId: trialProductId });
      return SubscriptionService.createBillingPortalSession({ redirectPath, updateSubscription: true, productId });
    },
    onSuccess: (billingSession: BillingSession) => (window.location.href = billingSession.url),
    onError: () => navigate(ROUTE_LINKS.billing)
  });

  useEffect(() => {
    const redirectPath = ShopifyService.isShopifyStoreDataInLocalStorage()
      ? ROUTE_LINKS.shopifyAuthHandler
      : ROUTE_LINKS.smartAssistants;
    subscriptionHandlingMutation.mutate({
      redirectPath,
      trialProductId: typeof trialProductId === 'string' ? trialProductId : undefined,
      productId: typeof productId === 'string' ? productId : undefined
    });
  }, []);

  return <FullScreenLoader />;
}
